import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  permissions: Array<any> = [];

  constructor(private router: Router) {
    if (window.localStorage.getItem('permissions')) {
      this.permissions = JSON.parse(localStorage.getItem('permissions'));
    }
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const requiredPermission = route.data['permission'];

    if (!requiredPermission) {
      return true;
    }

    const perm = this.permissions.find(
      (res) => res.permissionId === requiredPermission.id
    );
    if (perm && perm[requiredPermission.action] === 'true') {
      return true;
    }

    // Redirect to home/dashboard if permission is not granted
    this.router.navigate(['/home-page/dashboard']);
    return false;
  }
}
